import { Container } from '@mui/material'
import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import TableMui from 'src/components/TableMui'
import { State } from 'src/features/types'
import { useStore } from 'src/utils/store'
import { actions } from '../../BasicQueriesState'
import { CustomTextField } from '../../components/BasicQuery.styles'
import { BasicQueriesHeader } from '../../components/Header/Header'
import { ProductInfoCard } from '../../components/ProductInfoCard/ProductInfoCard'

interface Params {
  address: string
  batch: string
}

export const BatchDetail = () => {
  const { address, batch: idBatch } = useParams<Params>()
  const store = useStore()
  const dispatch = useDispatch()
  const batchInfo = useSelector((state: State) => state.basicQuery.batchInfo)
  const batchDetail = useSelector((state: State) => state.basicQuery.batchDetails)

  useEffect(() => {
    const state = store.getState()
    dispatch(actions.getBatchDetail({ address, batch: idBatch }))

    if (!state.basicQuery.batchInfo) {
      dispatch(actions.getAddressByBatch({ batch: idBatch }))
    }

    return () => {
      dispatch(actions.setBatchDetail())
    }
  }, [address, idBatch, dispatch, store])

  const resolveBatchesTableRows = useMemo(() => batchDetail?.map(({
    batch,
    stockBatchDue,
  }) => ({
    idBatch: batch.idLote,
    dueDate: batch.dataValidade,
    quantity: stockBatchDue.quantidade,
  })), [batchDetail])

  return (
    <Container>
      <BasicQueriesHeader title='Lote detalhado' />
      <CustomTextField
        disabled
        value={idBatch}
        name='batch'
        label='batch'
        testId='batch'
        variant='outlined'
        autoFocus
        fullWidth
        InputLabelProps={{ shrink: true }}
      />
      {batchInfo && (
        <ProductInfoCard
          description={batchInfo.productDescription}
          idModel={batchInfo.idModel}
          productCode={batchInfo.productCode}
        />
      )}
      <CustomTextField
        disabled
        value={address}
        name='address'
        label='address'
        testId='address'
        variant='outlined'
        autoFocus
        fullWidth
        InputLabelProps={{ shrink: true }}
      />
      {resolveBatchesTableRows && (
        <TableMui
          flatTable
          columns={[
            { id: 'quantity', label: 'Estoque' },
            {
              id: 'dueDate',
              label: 'Validade',
              isDate: true,
              dateFormat: 'DD/MM/YYYY',
            },
          ]}
          rows={resolveBatchesTableRows}
        />
      )}
    </Container>
  )
}
